import React from "react";
import { ApiUrl } from "../../config/apiConfig";
import EditableTextPage from "./EditableTextPage";


const PrivacyPolicy: React.FC = () => {
  return (
    <EditableTextPage
      title="Privacy Policy"
      fetchUrl={ApiUrl.list_policy}
      updateUrl={ApiUrl.addEditPrivacyPolicy}
    />
  );    
};

export default PrivacyPolicy;
